// extracted by mini-css-extract-plugin
export var aboveInput = "_kz-0";
export var actionButton = "_kz-5";
export var actionButtonContainer = "_kz-1";
export var actionIcon = "_kz-6";
export var aiInfoContainer = "_kz-2";
export var attachmentWrapper = "_kz-7";
export var bold = "_kz-3";
export var checkIcon = "_kz-8";
export var clickingRecipientBar = "_kz-11";
export var commentThreadSwitch = "_kz-a";
export var draftImage = "_kz-b";
export var draftImageContainer = "_kz-c";
export var draftImages = "_kz-e";
export var editButton = "_kz-g";
export var editor = "_kz-f";
export var editorContainer = "_kz-y";
export var editorErrorTooltipWrapper = "_kz-9";
export var headerDivider = "_kz-h";
export var icon = "_kz-i";
export var info = "_kz-j";
export var internal = "_kz-n";
export var internalDivider = "_kz-k";
export var internalMessage = "_kz-l";
export var messageInputCard = "_kz-m";
export var messageInputForm = "_kz-o";
export var messageInputFormInternal = "_kz-p";
export var options = "_kz-q";
export var publicMessageCustomer = "_kz-s";
export var publicMessageMerchant = "_kz-r";
export var removeImageButton = "_kz-d";
export var replyButtons = "_kz-t";
export var showSignatureButton = "_kz-u";
export var spinner = "_kz-v";
export var verticalButtonDivider = "_kz-4";
export var visibilitySelector = "_kz-w";
export var warning = "_kz-x";
export var wrappingText = "_kz-z";
export var writingInternalNoteTopBorder = "_kz-10";